import { sendGet, sendPost } from "src/utils/sendApi";

export const getUserPreferencesApi = sendGet("v1/data/user-preferences");

export const updateUserPreferencesApi = sendPost("v1/data/user-preferences");